<template>
<div v-if="!isIE" id="simple-keyboard" class="keyboard-wrapper slideInUp fast">
    <div id="simple-keyboard" class="inner-wrapper">
        <slot/>
        <!-- <keyboard-screen :input.sync="input" :onInputChange="onInputChange"></keyboard-screen> -->
        <div  class="simple-keyboard"></div>
    </div>
</div>
</template> 

<script>
import Vue from "vue";
import keypad from "simple-keyboard"
import Layout from "./hebrew.js"
let keyboard;
export default {
    props:["input"],
    data(){
            return{
                shift:"123",
                isIE : /*@cc_on!@*/false || !!document.documentMode
            }
        },
    watch:{
        input(newVal,oldVal){      
             let input =  newVal;
             keyboard.setInput(input);
        }
    },

    methods:{
        //  onInputChange(e) {
        //      let input = e.target.value;
        //      keypad.setInput(input);
        //  },
         onChange(input) {
             //this.update(input);
            // console.log("Input changed", input);
             //this.keyboardEvents.$emit("onChangeInput",input);
             this.$emit("onChangeInput",input);
          },
         onKeyPress(button) {
                //console.log("Button pressed", button);
             if (button === "{shift}" || button === "{lock}"){
              this.shift = this.shift === "123" ? "אבג" :"123"
              this.handleShift();
             }
             if(button == "{enter}"){
                 //this.keyboardEvents.$emit("enterClicked",this.input);
                 this.$emit("enterClicked",this.input);
             }
          },
          handleShift(){
              let currentLayout = keyboard.options.layoutName;
              let shiftToggle = currentLayout === "default" ? "shift" : "default";

              keyboard.setOptions({
              layoutName: shiftToggle,
              mergeDisplay:true,
              display:{
                    '{bksp}': 'bksp',
                    '{enter}': 'enter',
                    '{shift}':this.shift
                 }
               });
          } 
    },
    mounted(){
        //not working in IE
        if(this.isIE)return

        keyboard = new keypad({
          onChange: input => this.onChange(input),
          onKeyPress: button => this.onKeyPress(button),
          layout :Layout,
          theme:"hg-theme-default hg-layout-default myTheme",
          buttonTheme:[{class:"expend-space",buttons:"{space}"},],
          
          mergeDisplay:true,
          display:{
              '{bksp}': 'bksp',
              '{enter}': 'enter',
              '{shift}':this.shift
          }
        });
        keyboard.setInput(this.input);
    } ,
    inject:["keyboardEvents"]
}
</script>

<style scoped>
.fast{
    animation-duration: 250ms;
}
.keyboard-wrapper{
    position: fixed;
    z-index: 10000;
    bottom: 10px;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    /* background-color: #f4e2cb; */
    /* animation-name: wrap;
    animation-duration: 0.5s; */
    pointer-events: initial;
}
.inner-wrapper{
    width: 100%;
    max-width: 600px;
    position: relative;
}
@keyframes wrap{
  from{bottom: -100%;}
  to  {bottom : 10px;}
}

.simple-keyboard {
  max-width: 600px;
  /* margin: auto; */
  /* position: fixed;
  z-index: 10000;
  bottom: 10px; */
  /* left: calc(50% - 300px); */
  /* animation-name: wrap;
  animation-duration: 0.5s; */
  pointer-events: initial;
}
.simple-keyboard.hg-layout-default .hg-button.expend-space{
    flex-grow: 7;
}
.simple-keyboard.hg-layout-shift .hg-button.expend-space{
    flex-grow: 7;
}
.simple-keyboard.hg-theme-default.myTheme{
    background-color: lightgray ;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/keyboard/CustomKeyboard.vue